<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="1000px">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="110px"
    >
      <el-divider content-position="left">基本信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入公司名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主要联系人" prop="contactName">
            <el-input v-model="formData.contactName" placeholder="请输入主要联系人" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系手机" prop="mobile">
            <el-input
              v-model="formData.mobile"
              placeholder="请输入联系手机"
              @input="(v: string) => (formData.mobile = onlyDigits(v))"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="telephone">
            <el-input
              v-model="formData.telephone"
              placeholder="请输入联系电话"
              @input="(v: string) => (formData.telephone = onlyPhone(v))"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="微信号" prop="wechat">
            <el-input v-model="formData.wechat" placeholder="请输入微信号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="QQ" prop="qq">
            <el-input v-model="formData.qq" placeholder="请输入 QQ" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="formData.email" placeholder="请输入邮箱" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="其他" prop="otherInfo">
            <el-input v-model="formData.otherInfo" placeholder="其他补充信息" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户来源" prop="source">
            <el-select v-model="formData.source" class="w-1/1" placeholder="请选择客户来源">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_SOURCE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="showSourceOther" label="来源补充" prop="sourceOther">
            <el-input v-model="formData.sourceOther" placeholder="请填写客户来源补充说明" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="来访线索信息" prop="visitLeadInfo">
            <el-input
              v-model="formData.visitLeadInfo"
              :rows="2"
              type="textarea"
              placeholder="请输入来访线索信息"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">需求信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="需求分类" prop="requirementCategoryId">
            <el-select
              v-model="formData.requirementCategoryId"
              class="w-1/1"
              placeholder="请选择需求分类"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_REQUIREMENT_CATEGORY)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求概述" prop="requirementSummary">
            <el-input v-model="formData.requirementSummary" placeholder="请输入需求概述" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="需求详细说明" prop="requirementDetail">
            <el-input
              v-model="formData.requirementDetail"
              :rows="3"
              type="textarea"
              placeholder="请输入需求详细说明"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">客户属性</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户种类" prop="customerCategory">
            <el-select
              v-model="formData.customerCategory"
              class="w-1/1"
              clearable
              placeholder="请选择客户种类"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_CATEGORY)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户类型" prop="customerType">
            <el-select
              v-model="formData.customerType"
              class="w-1/1"
              clearable
              placeholder="请选择客户类型"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_TYPE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户状态" prop="customerStatus">
            <el-select
              v-model="formData.customerStatus"
              class="w-1/1"
              clearable
              placeholder="请选择客户状态"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_STATUS)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户等级" prop="level">
            <el-select
              v-model="formData.level"
              class="w-1/1"
              clearable
              placeholder="请选择客户等级"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_LEVEL)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="所属行业" prop="industryId">
            <el-select
              v-model="formData.industryId"
              class="w-1/1"
              clearable
              placeholder="请选择所属行业"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_INDUSTRY)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否建群" prop="groupCreated">
            <el-select
              v-model="formData.groupCreated"
              class="w-1/1"
              clearable
              placeholder="请选择是否建群"
            >
              <el-option :value="true" label="是" />
              <el-option :value="false" label="否" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否上市" prop="listed">
            <el-select
              v-model="formData.listed"
              class="w-1/1"
              clearable
              placeholder="请选择是否上市"
            >
              <el-option :value="true" label="是" />
              <el-option :value="false" label="否" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="社保人员" prop="socialSecurityStaff">
            <!-- 非必填；有值时才校验（不能为纯数字）⇒ 必填交给 rules，长度交给 maxlength（= crm_customer.social_security_staff 列宽） -->
            <el-input
              v-model="formData.socialSecurityStaff"
              :maxlength="64"
              placeholder="请输入社保人员"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">地址信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="所在地区" prop="areaId">
            <el-cascader
              v-model="formData.areaId"
              :options="areaList"
              :props="defaultProps"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择国家 / 省 / 市 / 区"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="detailAddress">
            <el-input v-model="formData.detailAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="官网" prop="website">
            <el-input v-model="formData.website" placeholder="请输入官网地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="交通路线" prop="trafficRoute">
            <el-input v-model="formData.trafficRoute" placeholder="请输入交通路线" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">工商信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="法人代表" prop="legalPerson">
            <el-input v-model="formData.legalPerson" placeholder="请输入法人代表" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册资本" prop="registeredCapital">
            <el-input v-model="formData.registeredCapital" placeholder="请输入注册资本" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="成立日期" prop="establishDate">
            <el-date-picker
              v-model="formData.establishDate"
              class="!w-1/1"
              placeholder="选择成立日期"
              type="datetime"
              value-format="x"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经营范围" prop="businessScope">
            <el-input v-model="formData.businessScope" placeholder="请输入经营范围" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">项目与报价</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目是否立项" prop="projectApproved">
            <el-select
              v-model="formData.projectApproved"
              class="w-1/1"
              clearable
              placeholder="请选择项目是否立项"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_PROJECT_APPROVED)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计上线时间" prop="expectedOnlineTime">
            <el-date-picker
              v-model="formData.expectedOnlineTime"
              class="!w-1/1"
              placeholder="选择预计上线时间"
              type="datetime"
              value-format="x"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="预算" prop="budget">
            <el-input-number
              v-model="formData.budget"
              class="!w-1/1"
              :min="0"
              :precision="2"
              placeholder="请输入预算"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报价" prop="quotation">
            <el-input-number
              v-model="formData.quotation"
              class="!w-1/1"
              :min="0"
              :precision="2"
              placeholder="请输入报价"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="报价备注" prop="quotationRemark">
            <el-input v-model="formData.quotationRemark" placeholder="请输入报价备注" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 三个附件一律「直接上传」，不走素材库：
           客户附件是甲方/乙方合同、报价单等业务凭据，不是运营选图素材，
           混进租户素材库会污染素材池，也让业务员多一步「先去素材库翻」的无谓操作。 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="甲方相关文件" prop="partyAFiles">
            <UploadFile
              v-model="formData.partyAFiles"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="乙方相关文件" prop="partyBFiles">
            <UploadFile
              v-model="formData.partyBFiles"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="报价附件" prop="quotationFiles">
            <UploadFile
              v-model="formData.quotationFiles"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider content-position="left">跟进与负责人</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="负责人" prop="ownerUserId">
            <el-select
              v-model="formData.ownerUserId"
              :disabled="formType !== 'create'"
              class="w-1/1"
              placeholder="请选择负责人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人职务" prop="ownerPosition">
            <el-input v-model="formData.ownerPosition" placeholder="请输入负责人职务" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="下次联系时间" prop="contactNextTime">
            <el-date-picker
              v-model="formData.contactNextTime"
              class="!w-1/1"
              placeholder="选择下次联系时间"
              type="datetime"
              value-format="x"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人备注" prop="ownerRemark">
            <el-input v-model="formData.ownerRemark" placeholder="请输入负责人备注" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              :rows="3"
              type="textarea"
              placeholder="请输入备注"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import * as CustomerApi from '@/api/crm/customer'
import * as AreaApi from '@/api/system/area'
import { defaultProps } from '@/utils/tree'
import * as UserApi from '@/api/system/user'
import { getCurrentUserId } from '@/utils/auth'
import { onlyDigits, onlyPhone } from '@/utils/inputFilter'
import { notPureNumber } from '@/utils/formRules'

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗

const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
const formType = ref('') // 表单的类型：create - 新增；update - 修改
const areaList = ref([]) // 地区列表
const userOptions = ref<UserApi.UserVO[]>([]) // 用户列表

/** 空表单数据（file 类字段必须是字符串，UploadFile 才会以「逗号分隔字符串」回写） */
const buildEmptyForm = () => ({
  id: undefined,
  name: undefined,
  contactName: undefined,
  contactNextTime: undefined,
  ownerUserId: 0,
  mobile: undefined,
  telephone: undefined,
  qq: undefined,
  wechat: undefined,
  email: undefined,
  otherInfo: undefined,
  areaId: undefined,
  detailAddress: undefined,
  industryId: undefined,
  level: undefined,
  source: undefined,
  sourceOther: undefined,
  visitLeadInfo: undefined,
  requirementCategoryId: undefined,
  requirementSummary: undefined,
  requirementDetail: undefined,
  customerCategory: undefined,
  customerStatus: undefined,
  customerType: undefined,
  groupCreated: undefined,
  budget: undefined,
  quotation: undefined,
  legalPerson: undefined,
  registeredCapital: undefined,
  establishDate: undefined,
  businessScope: undefined,
  ownerPosition: undefined,
  ownerRemark: undefined,
  socialSecurityStaff: undefined,
  listed: undefined,
  projectApproved: undefined,
  expectedOnlineTime: undefined,
  website: undefined,
  trafficRoute: undefined,
  partyAFiles: '',
  partyBFiles: '',
  quotationRemark: undefined,
  quotationFiles: '',
  remark: undefined
})

const formData = ref<any>(buildEmptyForm())
const formRules = reactive({
  name: [
    { required: true, message: '公司名称不能为空', trigger: 'blur' },
    notPureNumber('公司名称')
  ],
  contactName: [
    { required: true, message: '主要联系人不能为空', trigger: 'blur' },
    notPureNumber('主要联系人')
  ],
  // 非必填：留空放行（required 不参与），有填值时不能为纯数字 —— 与公司名称/主要联系人同口径
  socialSecurityStaff: [notPureNumber('社保人员')],
  mobile: [{ required: true, message: '联系手机不能为空', trigger: 'blur' }],
  source: [{ required: true, message: '客户来源不能为空', trigger: 'change' }],
  requirementCategoryId: [{ required: true, message: '需求分类不能为空', trigger: 'change' }],
  requirementSummary: [{ required: true, message: '需求概述不能为空', trigger: 'blur' }],
  ownerUserId: [{ required: true, message: '负责人不能为空', trigger: 'blur' }]
})
const formRef = ref() // 表单 Ref

/** 客户来源选择「其他 / 其它」时，展示补充说明输入框 */
const showSourceOther = computed(() => {
  const source = formData.value.source
  if (source === undefined || source === null) return false
  const dict = getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_SOURCE).find(
    (item) => item.value === Number(source)
  )
  return !!dict && /其他|其它/.test(dict.label)
})

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  // 修改时，设置数据
  if (id) {
    formLoading.value = true
    try {
      formData.value = await CustomerApi.getCustomer(id)
    } finally {
      formLoading.value = false
    }
  }
  // 获得地区列表
  areaList.value = await AreaApi.getAreaTree()
  // 获得用户列表
  userOptions.value = await UserApi.getSimpleUserList()
  // 默认新建时选中自己
  if (formType.value === 'create') {
    formData.value.ownerUserId = getCurrentUserId()
  }
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  // 提交请求
  formLoading.value = true
  try {
    const data = formData.value as unknown as CustomerApi.CustomerVO
    if (formType.value === 'create') {
      await CustomerApi.createCustomer(data)
      message.success(t('common.createSuccess'))
    } else {
      await CustomerApi.updateCustomer(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = buildEmptyForm()
  formRef.value?.resetFields()
}
</script>
